module.exports = __webpack_public_path__ + "static/media/texasImage.49208450.png";